module.exports = __webpack_public_path__ + "img/background.a45b9ddf.jpg";